import React, { useState, useEffect, useCallback } from 'react';
import { bannersAPI } from '../utils/api';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const BannerSlider = ({ position = 'landing', className = '' }) => {
  const [banners, setBanners] = useState([]);
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    bannersAPI.getAll(position, true)
      .then(res => setBanners(res.data))
      .catch(() => {});
  }, [position]);

  // Auto-slide every 5 seconds
  useEffect(() => {
    if (banners.length <= 1) return;
    const timer = setInterval(() => {
      setCurrent(prev => (prev + 1) % banners.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [banners.length]);

  const getImgSrc = useCallback((url) => {
    if (!url) return '';
    return url.startsWith('/') ? `${API_URL}${url}` : url;
  }, []);

  if (banners.length === 0) return null;

  const banner = banners[current];

  return (
    <div className={`bs-root ${className}`} data-testid={`banner-slider-${position}`}>
      <div className="bs-track">
        {banners.map((b, i) => (
          <div key={b.id} className={`bs-slide ${i === current ? 'active' : ''}`} data-testid={`banner-${b.id}`}>
            {b.link_url ? (
              <a href={b.link_url} target="_blank" rel="noopener noreferrer sponsored" className="bs-link">
                {b.image_url ? (
                  <img src={getImgSrc(b.image_url)} alt={b.title} className="bs-img" />
                ) : (
                  <div className="bs-placeholder">
                    <span className="bs-title">{b.title}</span>
                    {b.link_text && <span className="bs-cta">{b.link_text}</span>}
                  </div>
                )}
                {b.image_url && b.link_text && (
                  <div className="bs-overlay">
                    <span className="bs-overlay-cta">{b.link_text}</span>
                  </div>
                )}
              </a>
            ) : (
              <div className="bs-static">
                {b.image_url ? (
                  <img src={getImgSrc(b.image_url)} alt={b.title} className="bs-img" />
                ) : (
                  <div className="bs-placeholder">
                    <span className="bs-title">{b.title}</span>
                  </div>
                )}
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Dots */}
      {banners.length > 1 && (
        <div className="bs-dots">
          {banners.map((_, i) => (
            <button
              key={i}
              onClick={() => setCurrent(i)}
              className={`bs-dot ${i === current ? 'active' : ''}`}
              data-testid={`banner-dot-${i}`}
            />
          ))}
        </div>
      )}

      <div className="bs-label">Sponsored</div>

      <style>{`
        .bs-root {
          position: relative;
          max-width: 728px;
          margin: 12px auto;
          border-radius: 14px;
          overflow: hidden;
          background: #f0ece3;
          border: 1px solid rgba(0,0,0,0.06);
        }
        .bs-track { position: relative; min-height: 90px; }
        .bs-slide {
          position: absolute; inset: 0;
          opacity: 0; transition: opacity 0.5s ease;
          pointer-events: none;
        }
        .bs-slide.active { position: relative; opacity: 1; pointer-events: auto; }
        .bs-link, .bs-static { display: block; width: 100%; }
        .bs-img { width: 100%; height: auto; display: block; max-height: 180px; object-fit: cover; }
        .bs-placeholder {
          display: flex; flex-direction: column; align-items: center; justify-content: center;
          min-height: 90px; padding: 20px;
          background: linear-gradient(135deg, #1a1815 0%, #2d2a25 100%);
          color: white; text-align: center;
        }
        .bs-title { font-size: 16px; font-weight: 600; margin-bottom: 6px; }
        .bs-cta {
          display: inline-block; padding: 6px 18px; border-radius: 20px;
          background: #e8a824; color: #1a1815; font-size: 12px; font-weight: 700;
          margin-top: 6px;
        }
        .bs-overlay {
          position: absolute; bottom: 0; left: 0; right: 0;
          background: linear-gradient(transparent, rgba(0,0,0,0.7));
          padding: 16px; text-align: right;
        }
        .bs-overlay-cta {
          display: inline-block; padding: 5px 14px; border-radius: 16px;
          background: #e8a824; color: #1a1815; font-size: 11px; font-weight: 700;
        }
        .bs-dots {
          display: flex; gap: 6px; justify-content: center;
          padding: 8px 0;
        }
        .bs-dot {
          width: 6px; height: 6px; border-radius: 50%;
          background: #c4c0b8; border: none; cursor: pointer;
          transition: background 0.2s;
        }
        .bs-dot.active { background: #c4291c; width: 18px; border-radius: 3px; }
        .bs-label {
          position: absolute; top: 8px; right: 8px;
          font-size: 9px; font-weight: 600; color: #8a8580;
          text-transform: uppercase; letter-spacing: 0.5px;
          background: rgba(255,255,255,0.85); padding: 2px 8px; border-radius: 4px;
        }
        @media (max-width: 640px) {
          .bs-root { margin: 20px 0; border-radius: 10px; }
          .bs-title { font-size: 14px; }
          .bs-img { max-height: 140px; }
        }
      `}</style>
    </div>
  );
};

export default BannerSlider;
